module.exports = __webpack_public_path__ + "img/swarm.e07b0437.svg";